import {gpCommon, gpStorage} from "../GasPass";

export class Session {
    setClientAuthorized = null;

    constructor() {
        //
    }

    isSession() {
        try {
            if( this.get() != null ) {
                return true;
            }
        }
        catch( e ) {
            //
        }
        return false;
    }

    get() {
        try {
            let session = gpStorage.get( "session" );
            if( ( session != null ) && session.includes( ':' ) ) {
                let sessionParts = session.split( ':', 3 );

                let sessionId = gpCommon.getString( sessionParts[0], null );
                let sessionType = gpCommon.getString( sessionParts[1], null );
                let sessionToken = gpCommon.getString( sessionParts[2], null );

                if( ( sessionId != null ) && ( sessionType != null ) && ( sessionToken != null )
                    && ( /^[0-9]+$/.test( sessionId ) === true )
                    && ( ( sessionType === 'a' ) || ( sessionType === 'c' ) )
                ) {
                    return session;
                }
            }
        }
        catch( e ) {
            //
        }
        return null;
    }

    set( session ) {
        if( gpCommon.getString( session, null ) !== null ) {
            gpStorage.set( 'session', session );
            if( typeof this.setClientAuthorized == "function" ) {
                this.setClientAuthorized( true );
            }
        }
    }

    clear() {
        try {
            if( gpStorage.clearAll() ) {
                if( typeof this.setClientAuthorized == "function" ) {
                    this.setClientAuthorized( false );
                }
                return true;
            }
        }
        catch( e ) {
            //
        }
        return false;
    }

    setAuthorized( setClientAuthorized ) {
        this.setClientAuthorized = setClientAuthorized;
    }

}